module.exports = __webpack_public_path__ + "static/media/6.55159b2d.svg";